import React from 'react'
import { WHATSAPP_NUMBER } from '@constants/contact'
import Accordion from 'react-bootstrap/Accordion'
import AccordionHeaderContent from './AccordionHeaderContent'
import NotStartedStepMessage from './NotStartedStepMessage'
import IOrder from '@interfaces/IOrder'
import { getStepState } from '../utils/getStepState'

interface AccordionConfirmationProps {
  stepProgress: number
  inProgressOrder: IOrder | null
}

const AccordionConfirmation: React.FC<AccordionConfirmationProps> = ({
  stepProgress,
  inProgressOrder
}) => {
  const stepState = getStepState(stepProgress)

  const spermBankName = inProgressOrder?.selected_donor?.sperm_bank_id == 1 ? 'Pro-Seed' :
    inProgressOrder?.selected_donor?.sperm_bank_id == 2 ? 'European Sperm Bank' :
      inProgressOrder?.selected_donor?.sperm_bank_id == 3 ? 'Seattle Sperm Bank' : '-'

  return (
    <Accordion.Item eventKey="1" className={`${stepState}-state`}>
      <Accordion.Header>
        <AccordionHeaderContent
          stepState={stepState}
          progress={stepProgress}
          title="Confirmação de Reserva"
          subtitle={`Pedido: ${inProgressOrder?.internal_id}`}
        />
      </Accordion.Header>

      <Accordion.Body>
        <div className="check-sample p-3">
          {stepProgress < 1 ? (
            <NotStartedStepMessage />
          ) : stepState === 'completed' && inProgressOrder?.selected_donor ? (
            <>
              <div className="order-confirmed">
                <p className="mb-0">Parabéns! Sua reserva já está confirmada!</p>
              </div>
              <div className="order-confirmed mt-3">
                <p className="mb-0">
                  Confirmamos a reserva do doador <b>{inProgressOrder.selected_donor?.internal_id}</b>
                  {inProgressOrder.selected_donor?.nickname ? ` (${inProgressOrder.selected_donor?.nickname})` : ''}{' '}
                  do <b>{spermBankName}</b>.
                </p>
              </div>
              <div className="order-confirmed mt-3">
                <p className="mb-0">Você já pode seguir com o pagamento da amostra de sêmen.</p>
              </div>
            </>
          ) : (
            <>
              <div className="order-confirmed">
                <p className="mb-0">
                  Estamos analisando sua solicitação e assim que estiver confirmada, atualizaremos o status.<br />
                  <br />
                  Para reservar a amostra do seu doador escolhido consideramos tanto a disponibilidade de estoque quanto o controle do limite de nascimentos por doador para a sua região!<br />
                  <br />
                  Prazo de análise: <b>2 dias úteis</b>
                </p>
              </div>
              <div className="order-confirmed mt-3">
                <p className="mb-0">
                  Caso precise solicitar o cancelamento de seu pedido, por favor, entre em contato imediatamente
                  com nossa equipe através de nosso <a target="_blank" href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Preciso de informações sobre a minha reserva.')}`} rel="noreferrer"><b>WhatsApp</b></a>.
                </p>
              </div>
            </>
          )}
        </div>
      </Accordion.Body>
    </Accordion.Item>
  )
}

export default AccordionConfirmation
